import jsonApiNormalize from "json-api-normalize";
import { wrapArray } from "shared/utils/support";

// Usage: myNormalizer = Object.create(BaseNormalizer).init(attributes, collections)

// All children normalizers, except for `BaseNormalizer` are meant to be used directly
// i.e. not further inherited, hence the lowercase naming of children validators

// More information about OLOO style
// https://github.com/getify/You-Dont-Know-JS/blob/master/this%20%26%20object%20prototypes/ch6.md

const BaseNormalizer = {
  init(attributes = [], collections = []) {
    this.normalize = this.normalize.bind(this);
    this.attributes = attributes;
    this.collections = collections;
    return this;
  },

  normalize(raw) {
    if (!raw) {
      return null;
    }

    const result = jsonApiNormalize(raw).get(this.attributes);
    return Array.isArray(result)
      ? result.map(record => this.ensureCollectionsAreArrays(record))
      : this.ensureCollectionsAreArrays(result);
  },

  // Unfortunately, the json-api-normalize's behavior for
  // single records in an array is to objectify them
  //
  // We do not want this
  ensureCollectionsAreArrays(singleInput) {
    return Object.entries(singleInput).reduce(
      (accumulator, [attributeName, attributeValue]) => {
        const processedAttributeValue =
          this.collections.includes(attributeName) && attributeValue
            ? wrapArray(attributeValue)
            : attributeValue;
        return { ...accumulator, [attributeName]: processedAttributeValue };
      },
      {},
    );
  },
};

export default BaseNormalizer;
